import { Card, CardActionArea, useTheme } from "@mui/material";
import type { LucideIcon } from "lucide-react";
import type { FC } from "react";
import { CalloutContent } from "web_myplann/Shared/Components/CalloutContent";
import type {
	CalloutColor,
	CalloutVariant,
} from "web_myplann/Shared/Types/CalloutAppearance";

type Props = {
	variant?: CalloutVariant;
	color: CalloutColor;
	icon: LucideIcon;
	title: string;
	description: string;
	onClick?: () => void;
};

export const Callout: FC<Props> = ({
	variant = "tinted",
	color,
	icon,
	title,
	description,
	onClick,
}) => {
	const { callout } = useTheme();
	const appearance = callout[variant](color);

	return (
		<Card variant="outlined" sx={appearance.card}>
			{onClick ? (
				<CardActionArea component="div" onClick={onClick}>
					<CalloutContent
						appearance={appearance}
						icon={icon}
						title={title}
						description={description}
						showChevron
					/>
				</CardActionArea>
			) : (
				<CalloutContent
					appearance={appearance}
					icon={icon}
					title={title}
					description={description}
					showChevron={false}
				/>
			)}
		</Card>
	);
};
